export enum QualityBonus {
  GOLD = 'gold',
  SILVER = 'silver',
  BRONZE = 'bronze',
}

export enum QualityPremiumPartnerLevel {
  BRONZE = 1,
  SILVER = 2,
  GOLD = 3,
}

export enum DriverStatus {
  NONE = 'None',
  BRONZE = 'Bronze',
  SILVER = 'Silver',
  GOLD = 'Gold',
}
